import * as React from 'react';
import * as s from './QuoteInfo.scss';
import * as get from 'lodash.get';
import { Text } from 'wix-style-react';
import { dateFormat, localDate } from '../../../core';
import { translate } from 'react-i18next';
import { WithQuoteInfoLoader, } from '../../loaders/loaders-builder';
var QuoteInfo = function (_a) {
    var t = _a.t, priceQuote = _a.priceQuote, locale = _a.locale;
    var date = localDate(dateFormat({ locale: locale }));
    var issueDate = get(priceQuote.dates, 'issueDate');
    var validThroughDate = get(priceQuote.dates, 'validThroughDate');
    return (React.createElement("div", { className: s.info },
        React.createElement(Text, { className: s.number, weight: "thin", size: "tiny", dataHook: "price-quote-number" }, t('invoice-view:price-quote.view.price-quote-number', {
            number: priceQuote.number,
        })),
        !!issueDate && (React.createElement(Text, { className: s.date, weight: "thin", size: "tiny", dataHook: "issue-date" }, t('invoice-view:price-quote.view.issue-date', {
            date: date(new Date(issueDate)),
        }))),
        !!validThroughDate && (React.createElement(Text, { className: s.date, weight: "thin", size: "tiny", dataHook: "expiry-date" }, t('invoice-view:price-quote.view.expiry-date', {
            date: date(new Date(validThroughDate)),
        })))));
};
export default WithQuoteInfoLoader(translate(['invoice-view', 'locale-data'])(QuoteInfo));
//# sourceMappingURL=QuoteInfo.js.map